import React from 'react';
import appStyles from 'Routes/Routes.css';
import { checkIfPCIList } from 'Utils';
import clsx from 'clsx';

import styles from './Uploader.css';
import PCIFileUploader from '../PCIFileUploader';
import Footer from './Footer';
import { POSSIBLE_STATUS, useUploaderContext } from './context';
import ConfirmationModal from '../ConfirmationModal';
import ChunkingProcess from '../ChunkingProcess';
import Instructions from './Instructions';
import GenericListFileUploader from '../GenericListFileUploader';

function Uploader() {
    const { listType, status } = useUploaderContext();
    const isPCIList = checkIfPCIList(listType);
    const iframeRef = React.useRef<HTMLIFrameElement>(null);
    const isChunking = status === POSSIBLE_STATUS.chunking;

    return (
        <div className={appStyles.landingPage}>
            <div className={clsx(styles.FormContainer, isChunking && styles.chunking)}>
                <Instructions />
                {/* Perhaps have a component to handle which uploader shows up rather than ternary */}
                {/* This is fine for interim though */}
                {isPCIList ? <PCIFileUploader ref={iframeRef} /> : <GenericListFileUploader />}
                <ConfirmationModal isPCIList={isPCIList} ref={iframeRef} />
                {isChunking && <ChunkingProcess />}
                <Footer isPCIList={isPCIList} ref={iframeRef} />
            </div>
        </div>
    );
}

export default Uploader;
